import { useTheme } from 'styled-components';

export const HistoryIcon: React.FC = () => {
  const theme = useTheme();
  return (
    <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.54636 1L6.76652 3.15853L5.09952 7.75524C3.49332 7.75255 2.91289 7.75524 1 7.75524V9.13212C3.13653 9.13212 3.4424 9.12943 5.57893 9.13212H6.0583L6.22285 8.68032L7.27459 5.77602L9.03461 13.191L9.57836 15.5L10.3511 13.2554L12.3329 7.46816L12.9768 8.75183L13.1699 9.13189H18.4V7.75501H14.0214L12.8337 5.38127L12.104 3.91118L11.5674 5.46017L9.81451 10.559L8.07593 3.22985L7.54636 1Z"
        fill={theme.iceBlue}
        stroke={theme.iceBlue}
        strokeWidth="0.4"
      />
    </svg>
  );
};
